module.exports = __webpack_public_path__ + "img/loginbanner2.88955262.jpg";